import { ProductActionType } from '../../../../../core/enums/product-actions/product-action-type.enum';
import { GrocyDashboardService } from '../../../shared/services/dashboard.service';
import { GrocyDashboardProductForm } from '../../forms/dashboard-product.form';
import { GrocyDashboardForms } from '../../models/dashboard-forms.model';
import { GrocyDashboardSelectedProduct } from '../../models/dashboard-selected-product.model';

export abstract class GrocyActionDialogComponent {
  constructor(protected service: GrocyDashboardService) {}

  get forms(): GrocyDashboardForms {
    return this.service.forms;
  }

  get productActionType(): ProductActionType {
    return this.service.state.productActionType;
  }

  get productForm(): GrocyDashboardProductForm {
    return this.forms.product;
  }

  protected get selectedProduct(): GrocyDashboardSelectedProduct | undefined {
    return this.service.selectedProduct();
  }

  protected setProductActionType(productActionType: ProductActionType) {
    this.service.state.productActionType = productActionType;
  }
}
